// Furillo To Top Plugin
// The semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'formsAjaxPost';
    var defaults = { };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);
        
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        var $base = this;
        
        $base.$element.on('submit', function (e) {
            e.preventDefault();

            $base.submit();
        });
    };

    Plugin.prototype.submit = function () {
        var $base = this;

        if ($base.$element.data('submitted') !== true && $base.$element.valid()) {

            $base.$element.data('submitted', true);

            $.ajax({
                url: $base.$element.attr('action'),
                type: $base.$element.attr('method'),
                cache: false,
                data: new FormData($base.element),
                processData: false,
                contentType: false,
                success: function (result) {
                    var thankYouMessage = $(result).find('.umbraco-forms-submitmessage').first();

                    //Handles edge case where Recaptcha wasn't checked
                    if (thankYouMessage.length === 0) {
                        $(result).find('.field-validation-error').each(function (i, v) {
                            window.alert($(v).text());
                        });

                        $base.$element.data('submitted', false);
                    }
                    else {
                        $base.$element.html(thankYouMessage);
                    }
                }
            });

        }
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);